import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Importation du style par défaut de Quill
import '../../StylesCSS/InputNotes.css'; // Importer le fichier CSS pour la personnalisation
import { useUser } from '../../context/UserContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { API_BASE_URL } from '../dashboardContent/config'; 
import { useLocation, useNavigate } from 'react-router-dom';
import BranchLabelBanner from './BranchLabelBanner';

const InputNotes  = ({ setActiveSection })  => {
    const navigate = useNavigate();
    const location = useLocation();
    const routeContext = location.state || {};
    const {
        branch,
        branchLabel,
        action,
    } = routeContext;

    /* Start MSL30082026 */

    const [notes, setNotes] = useState('');
    const [isModalVisible, setIsModalVisible] = useState(false); // État pour le modal
    const { userId } = useUser();

    /* Start MSL30082026 */
    const handleChange = (value) => {
        setNotes(value);
    };

    const cleanHtmlToText = (html) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        return tempDiv.innerText; // Récupérer uniquement le texte
    };
    /* End MSL30082026 */

    /* Start MSL30082026 */
    const handleSaveNotes = async () => {
        const cleanedNotes = cleanHtmlToText(notes); // Nettoyer le texte avant l'envoi

        const payload = {
            notes: cleanedNotes,
            userId: userId.toString(),
            branch: branch || '',
            branchLabel: branchLabel || '',
        };

        console.log('=== InputNotes: envoi note ===');
        console.log('branch:', branch);
        console.log('branchLabel:', branchLabel);
        console.log('payload:', payload);

        const response = await fetch(`${API_BASE_URL}/version2/api/notes/save`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        });

        if (response.ok) {
            setNotes(''); // Réinitialiser le champ
            setIsModalVisible(true); // Afficher le modal
        } else {
            alert('Erreur lors de l\'enregistrement des notes.');
        }
    };
    const handleCloseModal = () => {
        setIsModalVisible(false); // Fermer le modal
    };
    /* End MSL30082026 */

    /* Start MSL30082026 */
    const handleGoBack = (section) => {
        navigate(`/${section}`, {
            state: {
                branch,
                branchLabel,
                action,
            },
        });
      };
    /* End MSL30082026 */

    return (
        <div className="input-notes-container" dir="rtl">
            <div style={{ marginBottom: '28px' }}>
                <BranchLabelBanner branchLabel={branchLabel} style={{ marginBottom: 0 }} />
            </div>
            <div className="input-notes-heading">
                <span>التوثيق والمتابعة</span>
                <h2 className="input-notes-title">إدخال الملاحظات</h2>
                <p>أدخل الملاحظات المتعلقة بالأنشطة أو المعطيات التي تريد حفظها.</p>
            </div>
            <div className="input-notes-editor-card">
            <ReactQuill 
                value={notes} 
                onChange={handleChange} 
                className="quill-editor" 
            />
            </div>
           <div className="button-container input-notes-actions">
            <button onClick={() => handleGoBack('PageLayout2V2')} className="back-btn">
                <FontAwesomeIcon icon={faArrowLeft} /> رجوع
            </button>
            <button className="submit-button" onClick={handleSaveNotes}>إرسال</button>

        </div>

            {/* Modal */}
            {isModalVisible && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h3>تم ارسال الملاحظات بنجاح!</h3>
                        <button onClick={handleCloseModal}>إغلاق</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default InputNotes;
